// extracted by mini-css-extract-plugin
module.exports = {"badgewrapper":"styles_badgewrapper__8zf1p","icon":"styles_icon__yAEZb"};
module.exports.__checksum = "a239d24a19ea"